import { useEffect } from 'react'
import faviconUrl from '../../../assets/favicon2.ico?url'

export function AnimatedFavicon() {
  useEffect(() => {
    const canvas = document.createElement('canvas')
    canvas.width = 64
    canvas.height = 64
    const ctx = canvas.getContext('2d')!

    const img = new Image()
    img.src = faviconUrl

    let angle = 0
    let rafId: number

    let link = document.querySelector<HTMLLinkElement>('link[rel~="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }

    const draw = () => {
      ctx.clearRect(0, 0, 64, 64)
      ctx.save()
      ctx.translate(32, 32)
      ctx.rotate(angle)
      ctx.drawImage(img, -32, -32, 64, 64)
      ctx.restore()
      link!.href = canvas.toDataURL('image/png')
      angle += (Math.PI * 2 * 5) / 60
      rafId = requestAnimationFrame(draw)
    }

    img.onload = () => draw()

    return () => cancelAnimationFrame(rafId)
  }, [])

  return null
}
